
export enum AgreementSigningProvider {
    Direct = 1,
    Docusign = 2
}
